(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const reveals = document.querySelectorAll('.irn-reveal');

  if (reduceMotion || !('IntersectionObserver' in window)) {
    reveals.forEach((element) => element.classList.add('is-visible'));
  } else {
    const revealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12 });

    reveals.forEach((element) => revealObserver.observe(element));
  }

  document.querySelectorAll('[data-irn-slider]').forEach((slider) => {
    const track = slider.querySelector('[data-irn-track]');
    slider.querySelectorAll('[data-irn-direction]').forEach((button) => {
      button.addEventListener('click', () => {
        const direction = button.dataset.irnDirection === 'next' ? 1 : -1;
        track.scrollBy({ left: track.clientWidth * 0.82 * direction, behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    });
  });

  document.querySelectorAll('[data-irn-count]').forEach((counter) => {
    const target = Number(counter.dataset.irnCount);
    if (!Number.isFinite(target)) return;

    const render = () => {
      if (reduceMotion) {
        counter.textContent = `${target}%`;
        return;
      }

      const startedAt = performance.now();
      const duration = 900;
      const step = (now) => {
        const progress = Math.min((now - startedAt) / duration, 1);
        counter.textContent = `${Math.round(target * (1 - Math.pow(1 - progress, 3)))}%`;
        if (progress < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };

    if (!('IntersectionObserver' in window)) {
      render();
      return;
    }

    const countObserver = new IntersectionObserver((entries, observer) => {
      if (!entries[0].isIntersecting) return;
      render();
      observer.disconnect();
    }, { threshold: 0.5 });
    countObserver.observe(counter);
  });
})();
